import React from 'react';
import { Navigate } from 'react-router-dom';
import { type PhoneEnrolChallenge, useAuth } from '../../context/AuthContext';
import { PhoneEnrolCard } from './components/PhoneEnrolCard';
import { PhoneVerifyCard } from './components/PhoneVerifyCard';

export const PhoneEnrol = () => {
  const auth = useAuth();

  const [mfaEnrolResponse, setMFAEnrolResponse] = React.useState<PhoneEnrolChallenge | null>(null);

  const onVerifyCode = async (verificationCode: string): Promise<void> => {
    if (!mfaEnrolResponse) {
      return;
    }

    return auth.verifyPhoneEnrolmentCode(mfaEnrolResponse, verificationCode);
  };

  const onSendCode = async (phoneNumber: string) => {
    try {
      const response = await auth.sendPhoneEnrolmentCode(phoneNumber);
      setMFAEnrolResponse(response);
    } catch (err) {
      if (err.code === 'auth/requires-recent-login') {
        await auth.logout();
        return;
      }

      throw err;
    }
  };

  const onResendCode = async () => {
    if (!mfaEnrolResponse) {
      return;
    }

    return onSendCode(mfaEnrolResponse.phoneNumber);
  };

  if (!auth.showEnrolMfa) {
    return <Navigate to='/login' />;
  }

  if (mfaEnrolResponse) {
    return <PhoneVerifyCard onVerifyCode={onVerifyCode} onResendCode={onResendCode} />;
  }

  return <PhoneEnrolCard onSendCode={onSendCode} />;
};
